module.exports = __webpack_public_path__ + "img/w3_circle_list_image_black.6f22b7e7.png";